<script lang="ts">
  import { trackSupportLinkClick } from "$lib/analytics"
  import { getNavContext } from "$lib/context"
  import { Help } from "@tastyworks/icons-2.0"
  import CobrowseSupport from "@tastyworks/shared-cobrowse/CobrowseSupport.svelte"
  import { Button } from "@tastyworks/ui-library"
  import { _ } from "svelte-i18n"
  import type { Readable } from "svelte/store"

  interface Props {
    cobrowseEnabled?: Readable<boolean>
  }

  let { cobrowseEnabled }: Props = $props()

  // gtm analytics
  const nav = getNavContext()

  let helpCenterHref = $_("helpLinks.helpCenter.href")
  let supportNumberHref = $_("helpLinks.supportNumber.href")
</script>

<div
  class="
    help-links
    bottom-2
    z-30
    inline-flex
    w-full
    flex-col
    items-start
    justify-end
    gap-2
    px-7
    py-6
    text-alerts-information
    transition-opacity
    font-small-400
    max-md:fixed
    md:absolute"
>
  <!-- desktop view -->
  <div
    class="help-center flex items-center gap-1 text-general-primary-label max-md:hidden"
  >
    {$_("helpLinks.helpCenter.label")}
    <Button
      variant="link"
      href={helpCenterHref}
      class="text-inherit no-underline font-small-400"
      onclick={() => trackSupportLinkClick(nav.currentStepId, "help center")}
      aria-label={$_("helpLinks.helpCenter.label")}
    >
      <Help class="w-5 icon-large" />
    </Button>
  </div>

  <div class="text-general-primary-label max-md:hidden">
    {$_("helpLinks.action")}

    <Button
      variant="link"
      href={supportNumberHref}
      class="text-general-hyperlink no-underline font-small-400"
      onclick={() => trackSupportLinkClick(nav.currentStepId, "call support")}
    >
      {$_("helpLinks.supportNumber.label")}
    </Button>
  </div>

  <!-- desktop cobrowse support -->
  {#if cobrowseEnabled && $cobrowseEnabled}
    <div class="text-general-primary-label max-md:hidden">
      <CobrowseSupport />
    </div>
  {/if}

  <!-- mobile view -->
  <div class="button-container flex w-full justify-between gap-3">
    <Button
      variant="default"
      href={helpCenterHref}
      class="flex w-full gap-1 text-button-primary font-large-525 md:hidden"
      onclick={() => trackSupportLinkClick(nav.currentStepId, "help center")}
    >
      {$_("helpLinks.helpCenter.label")}
      <Help class="w-5 icon-large" />
    </Button>

    <Button
      variant="default"
      href={supportNumberHref}
      class="flex w-full gap-1 text-button-primary font-large-525 md:hidden"
      onclick={() => trackSupportLinkClick(nav.currentStepId, "call support")}
    >
      {$_("helpLinks.action")}
    </Button>
  </div>

  <!-- mobile cobrowse support -->
  {#if cobrowseEnabled && $cobrowseEnabled}
    <div class="w-full md:hidden">
      <CobrowseSupport mobile />
    </div>
  {/if}
</div>
